import {
  PlaceableTile,
  TileType,
  TileColor,
  TileSymbol,
  ALL_COLORS,
  ALL_SYMBOLS,
  SACRED_SPRING,
} from '../config/tiles';

export interface TileQueueState {
  current: PlaceableTile;
  next: PlaceableTile;
  isFirstTile: boolean;
  rngCalls?: number;
}

export class TileQueue {
  private current: PlaceableTile;
  private next: PlaceableTile;
  private isFirstTile: boolean;
  private colors: TileColor[];
  private symbols: TileSymbol[];
  private rng: () => number;
  private rngCalls = 0;

  constructor(colors?: TileColor[], symbols?: TileSymbol[], state?: TileQueueState, rng?: () => number) {
    this.colors = colors ?? ALL_COLORS;
    this.symbols = symbols ?? ALL_SYMBOLS;
    this.rng = rng ?? Math.random;

    if (state) {
      this.current = state.current;
      this.next = state.next;
      this.isFirstTile = state.isFirstTile;
      if (state.rngCalls && rng) {
        for (let i = 0; i < state.rngCalls; i++) {
          rng();
        }
        this.rngCalls = state.rngCalls;
      }
    } else {
      this.isFirstTile = true;
      this.current = SACRED_SPRING;
      this.next = this.generateRandomTile();
    }
  }

  getCurrent(): PlaceableTile {
    return this.current;
  }

  getNext(): PlaceableTile {
    return this.next;
  }

  advance(): void {
    this.isFirstTile = false;
    this.current = this.next;
    this.next = this.generateRandomTile();
  }

  rewardSpring(): void {
    this.current = SACRED_SPRING;
  }

  replaceCurrent(tile: PlaceableTile): void {
    this.current = tile;
  }

  isFirstMove(): boolean {
    return this.isFirstTile;
  }

  getState(): TileQueueState {
    return {
      current: this.current,
      next: this.next,
      isFirstTile: this.isFirstTile,
      rngCalls: this.rngCalls,
    };
  }

  private generateRandomTile(): TileType {
    const color = this.colors[Math.floor(this.rng() * this.colors.length)];
    const symbol = this.symbols[Math.floor(this.rng() * this.symbols.length)];
    this.rngCalls += 2;
    return { color, symbol };
  }
}
